import { getTsdContactListDataWithUseForRegistrationByTsdId } from '../tsdContacts/mockData'
import { getTsdResourceListDataWithUseForRegistrationByTsdId } from '../tsdResources/mockData'
import { getSupplierOpportunityRegistrationEmailAddressListDataBySupplier } from '../suppliers/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { _storeEntityDataListToLocalForage } from '../../modules/mockDataStorageManager'
import type { ISupplier } from '~/types/supplier/models'
import type { ITsdSupplier } from '@/types/tsd/models'
import type { TEntityId } from '~/types/models'

const mn = '[api/msw/api/modules/tsdSuppliers/mockdData.ts]'
const tsdSupplierListData = undefined as unknown as ITsdSupplier[]

export const getTsdSupplierListData = getListDataFunctionFactory<
  ITsdSupplier[]
>({
  listData: tsdSupplierListData,
  storageKey: 'tsdsuppliers',
  getStartingListData: getStartingTsdSupplierListData,
})

export async function getTsdSupplierDataById(
  id: string
): Promise<ITsdSupplier | undefined> {
  const listData: ITsdSupplier[] = await getTsdSupplierListData()
  return listData.find((tsdSupplier) => tsdSupplier.id === id)
}

export async function getTsdSupplierListDataByTsdId(
  id: string
): Promise<ITsdSupplier[] | undefined> {
  const listData: ITsdSupplier[] = await getTsdSupplierListData()
  return listData.filter((tsdSupplier) => tsdSupplier.tsd.id === id)
}

export async function getTsdSupplierListDataBySupplierId(
  id: string
): Promise<ITsdSupplier[] | undefined> {
  const listData: ITsdSupplier[] = await getTsdSupplierListData()
  return listData.filter((tsdSupplier) => tsdSupplier.supplier.id === id)
}

export async function getTsdSupplierOpportunityRegistrationEmailAddressListDataByTsdSupplier(
  id: TEntityId
): Promise<(string | undefined)[]> {
  console.group()

  const tsdSupplier = await getTsdSupplierDataById(id)
  if (!tsdSupplier) {
    return []
  }
  console.debug('tsdSupplier:', tsdSupplier)

  const supplierId = tsdSupplier.supplier.id
  if (typeof supplierId !== 'string') {
    throw new TypeError(
      `Type Error: tsdSupplier.supplier.id is not a string. id: ${supplierId}`
    )
  }
  const theSupplierEmailAddresses =
    await getSupplierOpportunityRegistrationEmailAddressListDataBySupplier(
      supplierId
    )

  const tsdId = tsdSupplier.tsd.id
  if (typeof tsdId !== 'string') {
    throw new TypeError(
      `Type Error: tsdSupplier.tsd.id is not a string. id: ${tsdId}`
    )
  }
  const tsdContactsWithUseForRegistration =
    await getTsdContactListDataWithUseForRegistrationByTsdId(tsdId)
  console.debug(
    'tsdContactsWithUseForRegistration:',
    tsdContactsWithUseForRegistration
  )
  const tsdResourcesWithUseForRegistration =
    await getTsdResourceListDataWithUseForRegistrationByTsdId(tsdId)
  console.debug(
    'tsdResourcesWithUseForRegistration:',
    tsdResourcesWithUseForRegistration
  )

  const theContactsEmailsArray = tsdContactsWithUseForRegistration.map(
    (tc) => tc.email
  )
  console.debug('theContactsEmailsArray:', theContactsEmailsArray)
  const theResourcessEmailsArray = tsdResourcesWithUseForRegistration.map(
    (tr) => tr.email
  )
  console.debug('theResourcessEmailsArray', theResourcessEmailsArray)

  const theEmailsArray = theSupplierEmailAddresses?.length
    ? theSupplierEmailAddresses
    : theContactsEmailsArray.concat(theResourcessEmailsArray)
  console.debug('theEmailsArray:', theEmailsArray)
  console.groupEnd()
  return theEmailsArray
}

export async function updateSupplierInTsdSuppliers({
  targetItem: supplier,
}: {
  targetItem: ISupplier
}) {
  const fn = `${mn} updateSupplierInTsdSuppliers |`
  const list: ITsdSupplier[] = await getTsdSupplierListData()
  if (!list) {
    throw new Error(`tsdSupplierList returned undefined/null`)
  }
  for (const ts of list) {
    if (ts.supplier.id === supplier.id) {
      ts.supplier = { id: supplier.id, label: supplier.descr }
    }
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'tsdsuppliers',
    listData: list,
    callingFn: fn,
  })
}

export async function getStartingTsdSupplierListData(): Promise<
  ITsdSupplier[]
> {
  return [
    {
      id: 'XXTS0001',
      hrid: 'TS0001',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      splitFractionOverride: 1.0,
      numOpportunities: 4,
      numOrders: 3,
      numActiveServices: 3,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTS0002',
      hrid: 'TS0002',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      supplier: {
        id: 'XXS0007',
        label: '8X8',
      },
      splitFractionOverride: 1.0,
      numOpportunities: 3,
      numOrders: 6,
      numActiveServices: 3,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTS0003',
      hrid: 'TS0003',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      supplier: {
        id: 'XXS0005',
        label: 'RingCentral',
      },
      splitFractionOverride: 1.0,
      numOpportunities: 20,
      numOrders: 9,
      numActiveServices: 5,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTS0004',
      hrid: 'TS0004',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      splitFractionOverride: 0.12,
      numOpportunities: 19,
      numOrders: 4,
      numActiveServices: 4,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTS0005',
      hrid: 'TS0005',
      tsd: {
        id: 'XXT0002',
        label: 'Intelisys',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      splitFractionOverride: 0.14,
      numOpportunities: 0,
      numOrders: 0,
      numActiveServices: 0,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
  ]
}
